import React, { useState, useEffect,useContext, useRef } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso,FormatedPrice,ExportArticleButton,AddMarkExportForm} from '@gull'
import {Form} from 'react-bootstrap'
import axios from 'axios'
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';
import { useCookies} from 'react-cookie';

const useLoad = (section) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const requestIdRef = useRef(0);
    const [ca, setCa] = useState({});
    const [totalCa, setTotalCa] = useState({});
    const [totalCaOld, setTotalCaOld] = useState({});
    const [totalCaEcart, setTotalCaEcart] = useState({});
    const [totalCaEcartPercent, setTotalCaEcartPercent] = useState({});
    const [loading,setLoading]=useState(false)
    const [checked,setChecked]=useState(false) 
    const [paramUrl,setParamUrl]=useState('today')
    const [relance,setRelance]=useState(Date.now()) 
    const [validButton,setValidButton]=useState(false) 
    const [startPeriod,setStartPeriod]=useState('') 
    const [endPeriod,setEndPeriod]=useState('') 
    const [startPeriod2,setStartPeriod2]=useState('') 
    const [endPeriod2,setEndPeriod2]=useState('') 
    const [calendaire,setCalendaire]=useState(false) 
    const [kpiFilterList,setKpiFilterList]=useState([])
    let recupSection=(section) ? authParam.sections.filter(value=>value.id==section) : false
    //pour le filtre général
    let defaultKpiFilter = '';
    if(recupSection && recupSection[0]){
        if(recupSection[0].advanceparams?.default_kpi_filter) defaultKpiFilter=recupSection[0].advanceparams.default_kpi_filter
    }
    const [selectedFilter,setSelectedFilter]=useState(defaultKpiFilter)
    //pour les compariason
    let defaultKpiFilterCompare = {
        filter1:'',
        filter2:''
    };
    if(recupSection && recupSection[0]){
        if(recupSection[0].advanceparams?.default_kpi_filter_compare){
            let arr_compare = recupSection[0].advanceparams?.default_kpi_filter_compare.split('/!')
            if(arr_compare.length==2){
               defaultKpiFilterCompare.filter1= arr_compare[0]
               defaultKpiFilterCompare.filter2= arr_compare[1]
            }
        }
    }
    const [compareFilter,setCompareFilter]=useState({
        filter1:defaultKpiFilterCompare.filter1,
        filter2:defaultKpiFilterCompare.filter2
    })
    const [btnValidateCompareFilter,setBtnValidateCompareFilter]=useState(false)
    const [reloadCompareFilter,setReloadCompareFilter]=useState((defaultKpiFilterCompare.filter1!='') ? true : false)
    const [showCompare,setShowCompare]=useState(false)
    const [caCompare, setCaCompare] = useState({});
    const [totalCaCompare, setTotalCaCompare] = useState({});
    const [totalCaCompare2, setTotalCaCompare2] = useState({});
    const [totalCaRatioCompare, setTotalCaRatioCompare] = useState({});

    function getTodayDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    useEffect(function () {
        (async function() {
            setBtnValidateCompareFilter(true)
            if(reloadCompareFilter && (compareFilter.filter1!='' || compareFilter.filter2!='')){
                let obj = {
                    kpi_filter_id1:compareFilter.filter1,
                    kpi_filter_id2:compareFilter.filter2
                }
                if(section) obj.section=section

                const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ca/get_all_filter_compare/"+url,obj
                ).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach((interm)=>{
                            let finalMessage=interm.split('/!');
                            if(finalMessage.length==2){
                                messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                            }
                            else{
                                messageError+=t(interm)+'<br/>'
                            }
                        })
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                        setCaCompare({})
                        setTotalCaCompare({
                            totalCaTtc : 0,
                            totalCaHt : 0,
                            totalPm : 0,
                            totalPmTtc : 0,
                            totalMb : 0,
                            totalMbPercent : 0,
                            totalTgc : 0,
                            totalIv: 0,
                            totalTf: 0,
                            nbMbLine: 0,
                            nbArticles:0,
                            nbTickets:0
                        })
                        setTotalCaCompare2({
                            totalCaTtc : 0,
                            totalCaHt : 0,
                            totalPm : 0,
                            totalPmTtc : 0,
                            totalMb : 0,
                            totalMbPercent : 0,
                            totalTgc : 0,
                            totalIv: 0,
                            totalTf: 0,
                            nbMbLine: 0,
                            nbArticles:0,
                            nbTickets:0
                        })
                        setTotalCaRatioCompare({
                            totalCaTtc : 0,
                            totalCaHt : 0,
                            totalPm : 0,
                            totalPmTtc : 0,
                            totalMb : 0,
                            totalMbPercent : 0,
                            totalTgc : 0,
                            totalIv: 0,
                            totalTf: 0,
                            nbMbLine: 0,
                            nbArticles:0,
                            nbTickets:0
                        })
                    }else{
                        let obj = {
                            totalCaTtc : 0,
                            totalCaHt : 0,
                            totalPm : 0,
                            totalPmTtc : 0,
                            totalMb : 0,
                            totalMbPercent : 0,
                            totalTgc : 0,
                            totalIv: 0,
                            totalTf: 0,
                            nbEntre: 0,
                            nbMbLine: 0,
                            nbArticles:0,
                            nbTickets:0
                        }

                        let obj_compare = {
                            totalCaTtc : 0,
                            totalCaHt : 0,
                            totalPm : 0,
                            totalPmTtc : 0,
                            totalMb : 0,
                            totalMbPercent : 0,
                            totalTgc : 0,
                            totalIv: 0,
                            totalTf: 0,
                            nbEntre: 0,
                            nbMbLine: 0,
                            nbArticles:0,
                            nbTickets:0
                        }

                        let obj_ratio = {
                            totalCaTtc : 0,
                            totalCaHt : 0,
                            totalPm : 0,
                            totalPmTtc : 0,
                            totalMb : 0,
                            totalMbPercent : 0,
                            totalTgc : 0,
                            totalIv: 0,
                            totalTf: 0,
                            nbEntre: 0,
                            nbMbLine: 0,
                            nbArticles:0,
                            nbTickets:0
                        }

                        Object.values(response.data.datas).map(value=>{
                            obj.totalCaTtc = obj.totalCaTtc + value.cattc
                            obj.totalCaHt = obj.totalCaHt + value.caht
                            obj.totalMb = obj.totalMb + value.marge_brutte
                            obj.totalTgc = obj.totalTgc + value.tgc
                            obj.nbArticles = obj.nbArticles + value.nbr_articles
                            obj.nbTickets = obj.nbTickets + value.nbr_tickets
                            obj.totalTf = obj.totalTf + (value.tf || 0)
                            obj.nbEntre = obj.nbEntre + (value.entre || 0)

                            obj_compare.totalCaTtc = obj_compare.totalCaTtc + value.compare.cattc
                            obj_compare.totalCaHt = obj_compare.totalCaHt + value.compare.caht
                            obj_compare.totalMb = obj_compare.totalMb + value.compare.marge_brutte
                            obj_compare.totalTgc = obj_compare.totalTgc + value.compare.tgc
                            obj_compare.nbArticles = obj_compare.nbArticles + value.compare.nbr_articles
                            obj_compare.nbTickets = obj_compare.nbTickets + value.compare.nbr_tickets
                            obj_compare.totalTf = obj_compare.totalTf + (value.compare.tf || 0)
                            obj_compare.nbEntre = obj_compare.nbEntre + (value.compare.entre || 0)

                        })
                        obj.totalPm = (obj.nbTickets!=0) ? (obj.totalCaHt/obj.nbTickets).toFixed(2) : 0
                        obj.totalPmTtc = (obj.nbTickets!=0) ? (obj.totalCaTtc/obj.nbTickets).toFixed(2) : 0
                        obj.totalIv = (obj.nbTickets!=0) ? (obj.nbArticles/obj.nbTickets).toFixed(2) : 0

                        obj_compare.totalPm = (obj_compare.nbTickets!=0) ? (obj_compare.totalCaHt/obj_compare.nbTickets).toFixed(2) : 0
                        obj_compare.totalPmTtc = (obj_compare.nbTickets!=0) ? (obj_compare.totalCaTtc/obj_compare.nbTickets).toFixed(2) : 0
                        obj_compare.totalIv = (obj_compare.nbTickets!=0) ? (obj_compare.nbArticles/obj_compare.nbTickets).toFixed(2) : 0

                        obj_ratio.totalCaTtc = (obj_compare.totalCaTtc!=0) ? (Math.round((obj.totalCaTtc/obj_compare.totalCaTtc)*100*100))/100 : ((obj.totalCaTtc!=0) ? 100 : 0)
                        obj_ratio.totalCaHt = (obj_compare.totalCaHt!=0) ? (Math.round((obj.totalCaHt/obj_compare.totalCaHt)*100*100))/100 : ((obj.totalCaHt!=0) ? 100 : 0)
                        obj_ratio.totalPm = (obj_compare.totalPm!=0) ? (Math.round((obj.totalPm/obj_compare.totalPm)*100*100))/100 : ((obj.totalPm!=0) ? 100 : 0)
                        obj_ratio.totalPmTtc = (obj_compare.totalPmTtc!=0) ? (Math.round((obj.totalPmTtc/obj_compare.totalPmTtc)*100*100))/100 : ((obj.totalPmTtc!=0) ? 100 : 0)
                        obj_ratio.totalMb = (obj_compare.totalMb!=0) ? (Math.round((obj.totalMb/obj_compare.totalMb)*100*100))/100 : ((obj.totalMb!=0) ? 100 : 0)
                        obj_ratio.totalTgc = (obj_compare.totalTgc!=0) ? (Math.round((obj.totalTgc/obj_compare.totalTgc)*100*100))/100 : ((obj.totalTgc!=0) ? 100 : 0)
                        obj_ratio.nbArticles = (obj_compare.nbArticles!=0) ? (Math.round((obj.nbArticles/obj_compare.nbArticles)*100*100))/100 : ((obj.nbArticles!=0) ? 100 : 0)
                        obj_ratio.nbTickets = (obj_compare.nbTickets!=0) ? (Math.round((obj.nbTickets/obj_compare.nbTickets)*100*100))/100 : ((obj.nbTickets!=0) ? 100 : 0)
                        obj_ratio.totalIv = (obj_compare.totalIv!=0) ? (Math.round((obj.totalIv/obj_compare.totalIv)*100*100))/100 : ((obj.totalIv!=0) ? 100 : 0)
                        obj_ratio.totalTf = (obj_compare.totalTf!=0) ? (Math.round((obj.totalTf/obj_compare.totalTf)*100*100))/100 : ((obj.totalTf!=0) ? 100 : 0)
                        obj_ratio.nbEntre = (obj_compare.nbEntre!=0) ? (Math.round((obj.nbEntre/obj_compare.nbEntre)*100*100))/100 : ((obj.nbEntre!=0) ? 100 : 0)

                        setTotalCaCompare(obj)
                        setTotalCaCompare2(obj_compare)
                        setTotalCaRatioCompare(obj_ratio)
                        setCaCompare(response.data.datas)
                        setShowCompare(true)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    console.log(error)
                    let messageError = (error.response.status==403) ? t('forbiddenGeneral') : t('unknowError');
                    swal.fire(messageError, "", "error");
                    setCaCompare({})
                    setTotalCaCompare({
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    })
                    setTotalCaCompare2({
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    })
                    setTotalCaRatioCompare({
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    })
                })
            }
            else setShowCompare(false)
            setBtnValidateCompareFilter(false)
        })()
    }, [reloadCompareFilter])

    useEffect(function () {
        (async function() {
            let url = (section) ? process.env.REACT_APP_API_URL+"api/pos/kpi_filter/get_all/"+section : process.env.REACT_APP_API_URL+"api/pos/kpi_filter/get_all";
            const response = await axios.get(url
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach((interm)=>{
                        let finalMessage=interm.split('/!');
                        if(finalMessage.length==2){
                            messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                        }
                        else{
                            messageError+=t(interm)+'<br/>'
                        }
                    })
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                }else{
                    setKpiFilterList(response.data.datas)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
        })()
    }, [])

    let today = getTodayDate()

    let url = (!checked) ?  paramUrl : startPeriod+((endPeriod!='') ? '/'+endPeriod:'')

    useEffect(function () {
        (async function() {
            const currentRequestId = requestIdRef.current + 1;
            requestIdRef.current = currentRequestId;

            setLoading(true)

            let obj = {
                calendaire:calendaire
            }
            if(section) obj.section=section

            if (selectedFilter != '') {
                obj.kpi_filter_id = selectedFilter
            }

            if (checked) {
                obj.begin2 = startPeriod2
                obj.end2 = endPeriod2
            }

            const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ca/get_all/"+url,obj
            ).then((response) => {
                if (requestIdRef.current !== currentRequestId) return;
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach((interm)=>{
                        let finalMessage=interm.split('/!');
                        if(finalMessage.length==2){
                            messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                        }
                        else{
                            messageError+=t(interm)+'<br/>'
                        }
                    })
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                    setCa({})
                    setTotalCa({
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalGoalsTtc : 0,
                        totalGoalsHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    })
                    setTotalCaOld({
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalGoalsTtc : 0,
                        totalGoalsHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    })
                    setTotalCaEcart({
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalGoalsTtc : 0,
                        totalGoalsHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    })
                    setTotalCaEcartPercent({
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalGoalsTtc : 0,
                        totalGoalsHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    })
                }else{
                    let obj = {
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalGoalsTtc : 0,
                        totalGoalsHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbEntre: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    }

                    let obj_old = {
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalGoalsTtc : 0,
                        totalGoalsHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbEntre: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    }

                    let obj_ecart = {
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalGoalsTtc : 0,
                        totalGoalsHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbEntre: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    }

                    let obj_ecart_percent = {
                        totalCaTtc : 0,
                        totalCaHt : 0,
                        totalGoalsTtc : 0,
                        totalGoalsHt : 0,
                        totalPm : 0,
                        totalPmTtc : 0,
                        totalMb : 0,
                        totalMbPercent : 0,
                        totalTgc : 0,
                        totalIv: 0,
                        totalTf: 0,
                        nbEntre: 0,
                        nbMbLine: 0,
                        nbArticles:0,
                        nbTickets:0
                    }

                    Object.values(response.data.datas).map(value=>{
                        obj.totalCaTtc = obj.totalCaTtc + value.cattc
                        obj.totalCaHt = obj.totalCaHt + value.caht
                        obj.totalGoalsTtc = (value.objectifs.valid) ? obj.totalGoalsTtc + value.objectifs.period.cattc : 0
                        obj.totalGoalsHt = (value.objectifs.valid) ? obj.totalGoalsHt + value.objectifs.period.ca : 0
                        obj.totalMb = obj.totalMb + value.marge_brutte
                        obj.totalTgc = obj.totalTgc + value.tgc
                        obj.nbArticles = obj.nbArticles + value.nbr_articles
                        obj.nbTickets = obj.nbTickets + value.nbr_tickets
                        obj.totalTf = obj.totalTf + (value.tf || 0)
                        obj.nbEntre = obj.nbEntre + (value.entre || 0)

                        obj_old.totalCaTtc = obj_old.totalCaTtc + value.old.cattc
                        obj_old.totalCaHt = obj_old.totalCaHt + value.old.caht
                        obj_old.totalGoalsTtc = (value.old.objectifs.valid) ? obj_old.totalGoalsTtc + value.old.objectifs.period.cattc : 0
                        obj_old.totalGoalsHt = (value.old.objectifs.valid) ? obj_old.totalGoalsHt + value.old.objectifs.period.ca : 0
                        obj_old.totalMb = obj_old.totalMb + value.old.marge_brutte
                        obj_old.totalTgc = obj_old.totalTgc + value.old.tgc
                        obj_old.nbArticles = obj_old.nbArticles + value.old.nbr_articles
                        obj_old.nbTickets = obj_old.nbTickets + value.old.nbr_tickets
                        obj_old.totalTf = obj_old.totalTf + (value.old.tf || 0)
                        obj_old.nbEntre = obj_old.nbEntre + (value.old.entre || 0)

                        obj_ecart.totalCaTtc = obj_ecart.totalCaTtc + value.ecart.cattc
                        obj_ecart.totalCaHt = obj_ecart.totalCaHt + value.ecart.caht
                        obj_ecart.totalGoalsTtc = (value.ecart.objectifs.valid) ? obj_ecart.totalGoalsTtc + value.ecart.objectifs.cattc : 0
                        obj_ecart.totalGoalsHt = (value.ecart.objectifs.valid) ? obj_ecart.totalGoalsHt + value.ecart.objectifs.ca : 0
                        obj_ecart.totalMb = obj_ecart.totalMb + value.ecart.marge_brutte
                        obj_ecart.totalTgc = obj_ecart.totalTgc + value.ecart.tgc
                        obj_ecart.nbArticles = obj_ecart.nbArticles + value.ecart.nbr_articles
                        obj_ecart.nbTickets = obj_ecart.nbTickets + value.ecart.nbr_tickets
                        obj_ecart.totalPm = obj_ecart.totalPm + value.ecart.pmht
                        obj_ecart.totalPmTtc = obj_ecart.totalPmTtc + value.ecart.pmttc
                        obj_ecart.totalIv = (obj.totalIv - obj_old.totalIv).toFixed(2)
                        obj_ecart.totalTf = obj_ecart.totalTf + (value.ecart.tf || 0)
                        obj_ecart.nbEntre = obj_ecart.nbEntre + (value.ecart.entre || 0)

                    })
                    obj.totalPm = (obj.nbTickets!=0) ? (obj.totalCaHt/obj.nbTickets).toFixed(2) : 0
                    obj.totalPmTtc = (obj.nbTickets!=0) ? (obj.totalCaTtc/obj.nbTickets).toFixed(2) : 0
                    obj.totalIv = (obj.nbTickets!=0) ? (obj.nbArticles/obj.nbTickets).toFixed(2) : 0

                    obj_old.totalPm = (obj_old.nbTickets!=0) ? (obj_old.totalCaHt/obj_old.nbTickets).toFixed(2) : 0
                    obj_old.totalPmTtc = (obj_old.nbTickets!=0) ? (obj_old.totalCaTtc/obj_old.nbTickets).toFixed(2) : 0
                    obj_old.totalIv = (obj_old.nbTickets!=0) ? (obj_old.nbArticles/obj_old.nbTickets).toFixed(2) : 0

                    obj_ecart.totalPm = obj.totalPm - obj_old.totalPm
                    obj_ecart.totalPmTtc = obj.totalPmTtc - obj_old.totalPmTtc
                    obj_ecart.totalIv = (obj.totalIv - obj_old.totalIv).toFixed(2)

                    obj_ecart_percent.totalCaTtc = (obj_old.totalCaTtc!=0) ? (Math.round((obj_ecart.totalCaTtc/obj_old.totalCaTtc)*100*100))/100 : ((obj.totalCaTtc!=0) ? 100 : 0)
                    obj_ecart_percent.totalCaHt = (obj_old.totalCaHt!=0) ? (Math.round((obj_ecart.totalCaHt/obj_old.totalCaHt)*100*100))/100 : ((obj.totalCaHt!=0) ? 100 : 0)
                    obj_ecart_percent.totalGoalsTtc = (obj_old.totalGoalsTtc!=0) ? (Math.round((obj_ecart.totalGoalsTtc/obj_old.totalGoalsTtc)*100*100))/100 : ((obj.totalGoalsTtc!=0) ? 100 : 0)
                    obj_ecart_percent.totalGoalsHt = (obj_old.totalGoalsHt!=0) ? (Math.round((obj_ecart.totalGoalsHt/obj_old.totalGoalsHt)*100*100))/100 : ((obj.totalGoalsHt!=0) ? 100 : 0)
                    obj_ecart_percent.totalPm = (obj_old.totalPm!=0) ? (Math.round((obj_ecart.totalPm/obj_old.totalPm)*100*100))/100 : ((obj.totalPm!=0) ? 100 : 0)
                    obj_ecart_percent.totalPmTtc = (obj_old.totalPmTtc!=0) ? (Math.round((obj_ecart.totalPmTtc/obj_old.totalPmTtc)*100*100))/100 : ((obj.totalPmTtc!=0) ? 100 : 0)
                    obj_ecart_percent.totalMb = (obj_old.totalMb!=0) ? (Math.round((obj_ecart.totalMb/obj_old.totalMb)*100*100))/100 : ((obj.totalMb!=0) ? 100 : 0)
                    obj_ecart_percent.totalTgc = (obj_old.totalTgc!=0) ? (Math.round((obj_ecart.totalTgc/obj_old.totalTgc)*100*100))/100 : ((obj.totalTgc!=0) ? 100 : 0)
                    obj_ecart_percent.nbArticles = (obj_old.nbArticles!=0) ? (Math.round((obj_ecart.nbArticles/obj_old.nbArticles)*100*100))/100 : ((obj.nbArticles!=0) ? 100 : 0)
                    obj_ecart_percent.nbTickets = (obj_old.nbTickets!=0) ? (Math.round((obj_ecart.nbTickets/obj_old.nbTickets)*100*100))/100 : ((obj.nbTickets!=0) ? 100 : 0)
                    obj_ecart_percent.totalIv = (obj_old.totalIv!=0) ? (Math.round((obj_ecart.totalIv/obj_old.totalIv)*100*100))/100 : ((obj.totalIv!=0) ? 100 : 0)
                    obj_ecart_percent.totalTf = (obj_old.totalTf!=0) ? (Math.round((obj_ecart.totalTf/obj_old.totalTf)*100*100))/100 : ((obj.totalTf!=0) ? 100 : 0)
                    obj_ecart_percent.nbEntre = (obj_old.nbEntre!=0) ? (Math.round((obj_ecart.nbEntre/obj_old.nbEntre)*100*100))/100 : ((obj.nbEntre!=0) ? 100 : 0)

                    setLoading(false)
                    setTotalCa(obj)
                    setTotalCaOld(obj_old)
                    setTotalCaEcart(obj_ecart)
                    setTotalCaEcartPercent(obj_ecart_percent)
                    setCa(response.data.datas)
                }
                setLoading(false)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError = (error.response.status==403) ? t('forbiddenGeneral') : t('unknowError');
                swal.fire(messageError, "", "error");
                setCa({})
                setTotalCa({
                    totalCaTtc : 0,
                    totalCaHt : 0,
                    totalGoalsTtc : 0,
                    totalGoalsHt : 0,
                    totalPm : 0,
                    totalPmTtc : 0,
                    totalMb : 0,
                    totalMbPercent : 0,
                    totalTgc : 0,
                    totalIv: 0,
                    totalTf: 0,
                    nbMbLine: 0,
                    nbArticles:0,
                    nbTickets:0
                })
                setTotalCaOld({
                    totalCaTtc : 0,
                    totalCaHt : 0,
                    totalGoalsTtc : 0,
                    totalGoalsHt : 0,
                    totalPm : 0,
                    totalPmTtc : 0,
                    totalMb : 0,
                    totalMbPercent : 0,
                    totalTgc : 0,
                    totalIv: 0,
                    totalTf: 0,
                    nbMbLine: 0,
                    nbArticles:0,
                    nbTickets:0
                })
                setTotalCaEcart({
                    totalCaTtc : 0,
                    totalCaHt : 0,
                    totalGoalsTtc : 0,
                    totalGoalsHt : 0,
                    totalPm : 0,
                    totalPmTtc : 0,
                    totalMb : 0,
                    totalMbPercent : 0,
                    totalTgc : 0,
                    totalIv: 0,
                    totalTf: 0,
                    nbMbLine: 0,
                    nbArticles:0,
                    nbTickets:0
                })
                setTotalCaEcartPercent({
                    totalCaTtc : 0,
                    totalCaHt : 0,
                    totalGoalsTtc : 0,
                    totalGoalsHt : 0,
                    totalPm : 0,
                    totalPmTtc : 0,
                    totalMb : 0,
                    totalMbPercent : 0,
                    totalTgc : 0,
                    totalIv: 0,
                    totalTf: 0,
                    nbMbLine: 0,
                    nbArticles:0,
                    nbTickets:0
                })
                setLoading(false)
            })
            setValidButton(false)
        })()
    }, [relance,calendaire])

    return [loading,ca,caCompare,paramUrl,setParamUrl,setRelance,setStartPeriod,startPeriod,setEndPeriod,endPeriod,checked,setChecked,validButton,setValidButton,today,totalCa,totalCaCompare,url,totalCaOld,totalCaEcart,totalCaEcartPercent,totalCaCompare2,totalCaRatioCompare,calendaire,setCalendaire,startPeriod2,setStartPeriod2,endPeriod2,setEndPeriod2,kpiFilterList,selectedFilter,setSelectedFilter,compareFilter,setCompareFilter,btnValidateCompareFilter,setReloadCompareFilter,showCompare]
}

const TurnoverPos = ({section}) =>{
    const t = useTranslate();
    const [loading,ca,caCompare,paramUrl,setParamUrl,setRelance,setStartPeriod,startPeriod,setEndPeriod,endPeriod,checked,setChecked,validButton,setValidButton,today,totalCa,totalCaCompare,url,totalCaOld,totalCaEcart,totalCaEcartPercent,totalCaCompare2,totalCaRatioCompare,calendaire,setCalendaire,startPeriod2,setStartPeriod2,endPeriod2,setEndPeriod2,kpiFilterList,selectedFilter,setSelectedFilter,compareFilter,setCompareFilter,btnValidateCompareFilter,setReloadCompareFilter,showCompare] = useLoad(section)
    const { authParam } = useContext(IsAuthContext);
    const [lang, setLang] = useCookies(['lang']);
    const [addMark,setAddMark]=useState(true) 
    let devise = authParam.company.devise;
    let digit = (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    const moduleParams = (section) ? authParam.modules.find(value=>value.name=='pos') : authParam.modules.find(value=>value.name=='erp')

    let filtre = {calendaire:calendaire,begin2:startPeriod2,end2:endPeriod2}
    if (selectedFilter != '') {
        filtre.kpi_filter_id = selectedFilter
    }

    const handleChange = (e) =>{
        setParamUrl(e.target.value)
        setRelance(Date.now())
        setReloadCompareFilter(Date.now())
    }

    const handleChangeKpiFilter = (e) =>{
        setSelectedFilter(e.target.value)
        setRelance(Date.now())
    }

    const handleFiltrePeriod = () =>{
        setValidButton(true)
        setRelance(Date.now())
        setReloadCompareFilter(Date.now())
    }

    // Décale l'année d'une date "YYYY-MM-DD" de delta années
    const shiftYear = (dateStr, delta = -1) => {
        if (!dateStr) return dateStr;
        const pad = n => String(n).padStart(2, '0');
        const [y, m, d] = dateStr.split('-').map(Number);
        const newY = y + delta;

        // dernier jour du même mois dans la nouvelle année (gère 29/02)
        const maxDay = new Date(newY, m, 0).getDate();
        const newD = Math.min(d, maxDay);

        return `${newY}-${pad(m)}-${pad(newD)}`;
    };

    const handlePeriodChange = (value,name) =>{
        switch (name) {
            case 'startPeriod':
                setStartPeriod(value)                
                setStartPeriod2(shiftYear(value))                
                break;
            case 'endPeriod':
                setEndPeriod(value)                
                setEndPeriod2(shiftYear(value))                
                break;
            case 'startPeriod2':
                setStartPeriod2(value)                
                break;
            case 'endPeriod2':
                setEndPeriod2(value)                
                break;
            default:
                break;
        }
    }

    const handleClickCompareFilter = () => {
        setReloadCompareFilter(Date.now())
    }

    return(<>
            <div className="card p-3 mb-3">
                {/* SWITCH */}
                <div className="d-flex align-items-center mb-3">
                    <Form.Check
                        type="switch"
                        label={t('periodFilter')}
                        checked={checked}
                        onChange={() => setChecked(!checked)}
                    />
                </div>

                {/* MODE SIMPLE */}
                {!checked ? (
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <select
                                className="form-control"
                                onChange={(e) => handleChange(e)}
                            >
                                <option value="today">{t('today')}</option>
                                <option value="yesterday">{t('hier')}</option>
                                <option value="this_week">{t('currentWeek')}</option>
                                <option value="last_week">{t('lastWeek')}</option>
                                <option value="this_month">{t('currentMonth')}</option>
                                <option value="last_month">{t('lastMonth')}</option>
                                <option value="this_year">{t('currentYear')}</option>
                                <option value="last_year">{t('lastYear')}</option>
                            </select>
                        </div>

                        {(paramUrl === 'today' || paramUrl === 'yesterday') && (
                            <div className="col-md-6">
                                <Form.Check
                                    type="checkbox"
                                    label={t('compare_date')}
                                    checked={calendaire}
                                    onChange={() => setCalendaire(!calendaire)}
                                />
                            </div>
                        )}
                    </div>
                ) : (
                    /* MODE PERSONNALISÉ */
                    <div className="row">
                        <div className="col-md-10">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label>{t('beginningPeriod')}</label>
                                    <input
                                        value={startPeriod}
                                        type="date"
                                        className="form-control"
                                        max={today}
                                        onChange={(e) =>
                                            handlePeriodChange(e.target.value, 'startPeriod')
                                        }
                                    />

                                    <label className="mt-2">{t('endPeriod')}</label>
                                    <input
                                        value={endPeriod}
                                        type="date"
                                        className="form-control"
                                        max={today}
                                        onChange={(e) =>
                                            handlePeriodChange(e.target.value, 'endPeriod')
                                        }
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>{t('beginningPeriod')} 2</label>
                                    <input
                                        value={startPeriod2}
                                        type="date"
                                        className="form-control"
                                        max={today}
                                        onChange={(e) =>
                                            handlePeriodChange(e.target.value, 'startPeriod2')
                                        }
                                    />

                                    <label className="mt-2">{t('endPeriod')} 2</label>
                                    <input
                                        value={endPeriod2}
                                        type="date"
                                        className="form-control"
                                        max={today}
                                        onChange={(e) =>
                                            handlePeriodChange(e.target.value, 'endPeriod2')
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2 d-flex align-items-center">
                            <button
                                disabled={
                                    startPeriod === '' ||
                                    startPeriod2 === '' ||
                                    validButton
                                }
                                className="btn btn-primary w-100"
                                onClick={() => handleFiltrePeriod()}
                            >
                                {validButton ? (
                                    <div className="spinner-border spinner-border-sm"></div>
                                ) : (
                                    t('btnValidate')
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* FILTRE KPI */}
            <div className="card p-3 mb-3">
                <div className="row align-items-center">
                    <div className="col-md-3 fw-bold">
                        {t('itemFilter')} :
                    </div>
                    <div className="col-md-5">
                        <select
                            id="kpi_filter"
                            value={selectedFilter}
                            className="form-control"
                            onChange={(e) => handleChangeKpiFilter(e)}
                        >
                            <option value="">{t('noSelection')}</option>
                            {kpiFilterList?.map((value) => (
                                <option key={value.id} value={value.id}>
                                    {value.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            {(!section) &&
                <div className='row'>
                    <div className='d-flex '>
                        <ExportArticleButton lang={lang.lang} filtre={filtre} header={[]} addMark={addMark} title={t('downloadCSVPeriod')} type="button" url={"api/pos/ca/csvitem/"+url}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                        <AddMarkExportForm setAddMark={setAddMark} addMark={addMark} />
                    </div>
                </div>
            }
            <div className='row'>
                <div className='col-auto'>
                    <CardPerso header={t('cattc')}>
                        <div className="table-responsive">
                            <table
                                id="stock_table"
                                className="table"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">{t('shop')}</th>
                                        <th className='text-end' scope="col">{t('cattc')}</th>
                                        <th className='text-end' scope="col">{t('cattc')+' P2'}</th>
                                        <th className='text-end' scope="col">{'ecart'}</th>
                                        <th className='text-end' scope="col">{'ecart %'}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(loading) ? 
                                        <tr>
                                            <td className="spinner-border spinner-border-sm mt-2"></td>
                                        </tr>
                                    :
                                    
                                        <>
                                            {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                if(hide.length==0){
                                                    return(
                                                        <tr key={key}>
                                                            <td>{key}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.cattc} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.old.cattc} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ecart.cattc} />}</td>
                                                            <td className='text-end'>{value.ecart_percent.cattc} %</td>
                                                        </tr>
                                                        
                                                    )
                                                }
                                            })}
                                            {(!section) &&
                                                <tr className='fw-bold'>
                                                    <td>Total</td>
                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCa.totalCaTtc} />}</td>
                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaOld.totalCaTtc} />}</td>
                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaEcart.totalCaTtc} />}</td>
                                                    <td className='text-end'>{totalCaEcartPercent.totalCaTtc} %</td>
                                                </tr>
                                            }
                                        </>

                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardPerso>
                </div>
                {(moduleParams.params.objectifs.active && selectedFilter=='') &&
                    <div className='col-auto'>
                        <CardPerso header={t('goalsttc')}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">{t('goalsttc')}</th>
                                            <th className='text-end' scope="col">{t('goalsttc')+' P2'}</th>
                                            <th className='text-end' scope="col">{'ecart'}</th>
                                            <th className='text-end' scope="col">{'ecart %'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(loading) ? 
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :
                                        
                                            <>
                                                {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(value.objectifs.valid) ? value.objectifs.period.cattc : 0} />}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(value.old.objectifs.valid) ? value.old.objectifs.period.cattc : 0} />}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(value.ecart.objectifs.valid) ? value.ecart.objectifs.cattc : 0} />}</td>
                                                                <td className='text-end'>{value.ecart_percent.objectifs.cattc} %</td>
                                                            </tr>
                                                            
                                                        )
                                                    }
                                                })}
                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCa.totalGoalsTtc} />}</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaOld.totalGoalsTtc} />}</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaEcart.totalGoalsTtc} />}</td>
                                                        <td className='text-end'>{totalCaEcartPercent.totalGoalsTtc} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                }
                {(!section) &&
                    <>
                        <div className='col-auto'>
                            <CardPerso header={t('caht')}>
                                <div className="table-responsive">
                                    <table
                                        id="stock_table"
                                        className="table"
                                    >
                                        <thead>
                                            <tr>
                                                <th scope="col">{t('shop')}</th>
                                                <th className='text-end' scope="col">{t('caht')}</th>
                                                <th className='text-end' scope="col">{t('caht')+' P2'}</th>
                                                <th className='text-end' scope="col">{'ecart'}</th>
                                                <th className='text-end' scope="col">{'ecart %'}</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {(loading) ? 
                                                <tr>
                                                    <td className="spinner-border spinner-border-sm mt-2"></td>
                                                </tr>
                                            :
                                            
                                                <>
                                                    {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                        let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                        if(hide.length==0){
                                                            return(
                                                                <tr key={key}>
                                                                    <td>{key}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.caht} />}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.old.caht} />}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ecart.caht} />}</td>
                                                                    <td className='text-end'>{value.ecart_percent.caht} %</td>
                                                                </tr>
                                                                
                                                            )
                                                        }
                                                    })}

                                                    {(!section) &&
                                                        <tr className='fw-bold'>
                                                            <td>Total</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCa.totalCaHt} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaOld.totalCaHt} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaEcart.totalCaHt} />}</td>
                                                            <td className='text-end'>{totalCaEcartPercent.totalCaHt} %</td>
                                                        </tr>
                                                    }
                                                </>

                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </CardPerso>
                        </div>
                        {(moduleParams.params.objectifs.active  && selectedFilter=='') && 
                            <div className='col-auto'>
                                <CardPerso header={t('goalsht')}>
                                    <div className="table-responsive">
                                        <table
                                            id="stock_table"
                                            className="table"
                                        >
                                            <thead>
                                                <tr>
                                                    <th scope="col">{t('shop')}</th>
                                                    <th className='text-end' scope="col">{t('goalsht')}</th>
                                                    <th className='text-end' scope="col">{t('goalsht')+' P2'}</th>
                                                    <th className='text-end' scope="col">{'ecart'}</th>
                                                    <th className='text-end' scope="col">{'ecart %'}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {(loading) ? 
                                                    <tr>
                                                        <td className="spinner-border spinner-border-sm mt-2"></td>
                                                    </tr>
                                                :
                                                
                                                    <>
                                                        {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                            let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                            if(hide.length==0){
                                                                return(
                                                                    <tr key={key}>
                                                                        <td>{key}</td>
                                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(value.objectifs.valid) ? value.objectifs.period.ca : 0} />}</td>
                                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(value.old.objectifs.valid) ? value.old.objectifs.period.ca : 0} />}</td>
                                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(value.ecart.objectifs.valid) ? value.ecart.objectifs.ca : 0} />}</td>
                                                                        <td className='text-end'>{value.ecart_percent.objectifs.ca} %</td>
                                                                    </tr>
                                                                    
                                                                )
                                                            }
                                                        })}

                                                        {(!section) &&
                                                            <tr className='fw-bold'>
                                                                <td>Total</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCa.totalGoalsHt} />}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaOld.totalGoalsHt} />}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaEcart.totalGoalsHt} />}</td>
                                                                <td className='text-end'>{totalCaEcartPercent.totalGoalsHt} %</td>
                                                            </tr>
                                                        }
                                                    </>

                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </CardPerso>
                            </div>
                        }
                    </>
                }
                {(!section) &&
                    <>
                        <div className='col-auto'>
                            <CardPerso header={t('grossMargin')}>
                                <div className="table-responsive">
                                    <table
                                        id="stock_table"
                                        className="table"
                                    >
                                        <thead>
                                            <tr>
                                                <th scope="col">{t('shop')}</th>
                                                <th className='text-end' scope="col">{t('grossMargin')}</th>
                                                <th className='text-end' scope="col">{t('grossMargin')+' P2'}</th>
                                                <th className='text-end' scope="col">{'ecart'}</th>
                                                <th className='text-end' scope="col">{'ecart %'}</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {(loading) ? 
                                                <tr>
                                                    <td className="spinner-border spinner-border-sm mt-2"></td>
                                                </tr>
                                            :
                                            
                                                <>
                                                    {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                        let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                        if(hide.length==0){
                                                            return(
                                                                <tr key={key}>
                                                                    <td>{key}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.marge_brutte} />}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.old.marge_brutte} />}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ecart.marge_brutte} />}</td>
                                                                    <td className='text-end'>{value.ecart_percent.marge_brutte} %</td>
                                                                </tr>
                                                                
                                                            )
                                                        }
                                                    })}

                                                    {(!section) &&
                                                        <tr className='fw-bold'>
                                                            <td>Total</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCa.totalMb} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaOld.totalMb} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaEcart.totalMb} />}</td>
                                                            <td className='text-end'>{totalCaEcartPercent.totalMb} %</td>
                                                        </tr>
                                                    }
                                                </>

                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </CardPerso>
                        </div>
                        <div className='col-auto'>
                            <CardPerso header={t('grossMarginPercent')}>
                                <div className="table-responsive">
                                    <table
                                        id="stock_table"
                                        className="table"
                                    >
                                        <thead>
                                            <tr>
                                                <th scope="col">{t('shop')}</th>
                                                <th className='text-end' scope="col">{t('grossMarginPercent')}</th>
                                                <th className='text-end' scope="col">{t('grossMarginPercent')+' P2'}</th>
                                                <th className='text-end' scope="col">{'ecart %'}</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {(loading) ? 
                                                <tr>
                                                    <td className="spinner-border spinner-border-sm mt-2"></td>
                                                </tr>
                                            :
                                            
                                                <>
                                                    {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                        let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                        if(hide.length==0){
                                                            return(
                                                                <tr key={key}>
                                                                    <td>{key}</td>
                                                                    <td className='text-end'>{(value.marge_brutte_percent!='-') ? value.marge_brutte_percent+' %' : value.marge_brutte_percent}</td>
                                                                    <td className='text-end'>{(value.old.marge_brutte_percent!='-') ? value.old.marge_brutte_percent+' %' : value.old.marge_brutte_percent}</td>
                                                                    <td className='text-end'>{(value.ecart.marge_brutte_percent!='-') ? value.ecart.marge_brutte_percent+' %' : value.ecart.marge_brutte_percent}</td>
                                                                </tr>
                                                                
                                                            )
                                                        }
                                                    })}

                                                    {(!section) &&
                                                        <tr className='fw-bold'>
                                                            <td>Total</td>
                                                            <td className='text-end'>{totalCa.totalCaHt!=0 ? Math.round((+totalCa.totalMb / +totalCa.totalCaHt) * 100) : 0} %</td>
                                                            <td className='text-end'>{totalCaOld.totalCaHt!=0 ? Math.round((+totalCaOld.totalMb / +totalCaOld.totalCaHt) * 100) : 0} %</td>
                                                            <td className='text-end'>{(totalCa.totalCaHt!=0 ? Math.round((+totalCa.totalMb / +totalCa.totalCaHt) * 100) : 0)-(totalCaOld.totalCaHt!=0 ? Math.round((+totalCaOld.totalMb / +totalCaOld.totalCaHt) * 100) : 0)} %</td>
                                                        </tr>
                                                    }
                                                </>

                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </CardPerso>
                        </div>
                        <div className='col-auto'>
                            <CardPerso header={authParam.company.nomenclature_tgc}>
                                <div className="table-responsive">
                                    <table
                                        id="stock_table"
                                        className="table"
                                    >
                                        <thead>
                                            <tr>
                                                <th scope="col">{t('shop')}</th>
                                                <th className='text-end' scope="col">{authParam.company.nomenclature_tgc}</th>
                                                <th className='text-end' scope="col">{authParam.company.nomenclature_tgc+' P2'}</th>
                                                <th className='text-end' scope="col">{'ecart'}</th>
                                                <th className='text-end' scope="col">{'ecart %'}</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {(loading) ? 
                                                <tr>
                                                    <td className="spinner-border spinner-border-sm mt-2"></td>
                                                </tr>
                                            :
                                            
                                                <>
                                                    {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                        let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                        if(hide.length==0){
                                                            return(
                                                                <tr key={key}>
                                                                    <td>{key}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.tgc} />}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.old.tgc} />}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ecart.tgc} />}</td>
                                                                    <td className='text-end'>{value.ecart_percent.tgc} %</td>
                                                                </tr>
                                                                
                                                            )
                                                        }
                                                    })}

                                                    {(!section) &&
                                                        <tr className='fw-bold'>
                                                            <td>Total</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCa.totalTgc} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaOld.totalTgc} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaEcart.totalTgc} />}</td>
                                                            <td className='text-end'>{totalCaEcartPercent.totalTgc} %</td>
                                                        </tr>
                                                    }
                                                </>

                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </CardPerso>
                        </div>
                    </>
                }
                <div className='col-auto'>
                    <CardPerso header={"PM TTC"}>
                        <div className="table-responsive">
                            <table
                                id="stock_table"
                                className="table"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">{t('shop')}</th>
                                        <th className='text-end' scope="col">PM TTC</th>
                                        <th className='text-end' scope="col">PM TTC P2</th>
                                        <th className='text-end' scope="col">{'ecart'}</th>
                                        <th className='text-end' scope="col">{'ecart %'}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(loading) ? 
                                        <tr>
                                            <td className="spinner-border spinner-border-sm mt-2"></td>
                                        </tr>
                                    :
                                    
                                        <>
                                            {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                if(hide.length==0){
                                                    return(
                                                        <tr key={key}>
                                                            <td>{key}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.pmttc} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.old.pmttc} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ecart.pmttc} />}</td>
                                                            <td className='text-end'>{value.ecart_percent.pmttc} %</td>
                                                        </tr>
                                                        
                                                    )
                                                }
                                            })}

                                            {(!section) &&
                                                <tr className='fw-bold'>
                                                    <td>Total</td>
                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCa.totalPmTtc} />}</td>
                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaOld.totalPmTtc} />}</td>
                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaEcart.totalPmTtc} />}</td>
                                                    <td className='text-end'>{totalCaEcartPercent.totalPmTtc} %</td>
                                                </tr>
                                            }
                                        </>

                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardPerso>
                </div>
                {(!section) &&
                    <div className='col-auto'>
                        <CardPerso header={'PM'}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">PM</th>
                                            <th className='text-end' scope="col">PM P2</th>
                                            <th className='text-end' scope="col">{'ecart'}</th>
                                            <th className='text-end' scope="col">{'ecart %'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(loading) ? 
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :
                                        
                                            <>
                                                {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.pmht} />}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.old.pmht} />}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ecart.pmht} />}</td>
                                                                <td className='text-end'>{value.ecart_percent.pmht} %</td>
                                                            </tr>
                                                            
                                                        )
                                                    }
                                                })}

                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(totalCa.nbTickets!=0) ? totalCa.totalCaHt/totalCa.nbTickets : 0} />}</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(totalCaOld.nbTickets!=0) ? totalCaOld.totalCaHt/totalCaOld.nbTickets : 0} />}</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={((totalCa.nbTickets!=0) ? totalCa.totalCaHt/totalCa.nbTickets : 0)-((totalCaOld.nbTickets!=0) ? totalCaOld.totalCaHt/totalCaOld.nbTickets : 0)} />}</td>
                                                        <td className='text-end'>{totalCaEcartPercent.totalPm} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                }
                <div className='col-auto'>
                    <CardPerso header={'IV'}>
                        <div className="table-responsive">
                            <table
                                id="stock_table"
                                className="table"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">{t('shop')}</th>
                                        <th className='text-end' scope="col">IV</th>
                                        <th className='text-end' scope="col">IV P2</th>
                                        <th className='text-end' scope="col">{'ecart'}</th>
                                        <th className='text-end' scope="col">{'ecart %'}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(loading) ? 
                                        <tr>
                                            <td className="spinner-border spinner-border-sm mt-2"></td>
                                        </tr>
                                    :
                                    
                                        <>
                                            {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                if(hide.length==0){
                                                    return(
                                                        <tr key={key}>
                                                            <td>{key}</td>
                                                            <td className='text-end'>{(value.objectifs.valid) ? value.iv : 0}</td>
                                                            <td className='text-end'>{(value.old.objectifs.valid) ? value.old.iv : 0}</td>
                                                            <td className='text-end'>{(value.ecart.objectifs.valid) ? value.ecart.iv : 0}</td>
                                                            <td className='text-end'>{(value.ecart_percent.objectifs.valid) ? value.ecart_percent.iv : 0} %</td>
                                                        </tr>
                                                        
                                                    )
                                                }
                                            })}

                                            {(!section) &&
                                                <tr className='fw-bold'>
                                                    <td>Total</td>
                                                    <td className='text-end'>{totalCa.totalIv}</td>
                                                    <td className='text-end'>{totalCaOld.totalIv}</td>
                                                    <td className='text-end'>{totalCaEcart.totalIv}</td>
                                                    <td className='text-end'>{totalCaEcartPercent.totalIv} %</td>
                                                </tr>
                                            }
                                        </>

                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardPerso>
                </div>
                <div className='col-auto'>
                    <CardPerso header={t('itemsNumber')}>
                        <div className="table-responsive">
                            <table
                                id="stock_table"
                                className="table"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">{t('shop')}</th>
                                        <th className='text-end' scope="col">{t('itemsNumber')}</th>
                                        <th className='text-end' scope="col">{t('itemsNumber')} P2</th>
                                        <th className='text-end' scope="col">{'ecart'}</th>
                                        <th className='text-end' scope="col">{'ecart %'}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(loading) ? 
                                        <tr>
                                            <td className="spinner-border spinner-border-sm mt-2"></td>
                                        </tr>
                                    :
                                    
                                        <>
                                            {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                if(hide.length==0){
                                                    return(
                                                        <tr key={key}>
                                                            <td>{key}</td>
                                                            <td className='text-end'>{Math.round(value.nbr_articles*100)/100}</td>
                                                            <td className='text-end'>{Math.round(value.old.nbr_articles*100)/100}</td>
                                                            <td className='text-end'>{Math.round(value.ecart.nbr_articles*100)/100}</td>
                                                            <td className='text-end'>{Math.round(value.ecart_percent.nbr_articles*100)/100} %</td>
                                                        </tr>
                                                        
                                                    )
                                                }
                                            })}

                                            {(!section) &&
                                                <tr className='fw-bold'>
                                                    <td>Total</td>
                                                    <td className='text-end'>{Math.round(totalCa.nbArticles*100)/100}</td>
                                                    <td className='text-end'>{Math.round(totalCaOld.nbArticles*100)/100}</td>
                                                    <td className='text-end'>{Math.round(totalCaEcart.nbArticles*100)/100}</td>
                                                    <td className='text-end'>{Math.round(totalCaEcartPercent.nbArticles*100)/100} %</td>
                                                </tr>
                                            }
                                        </>

                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardPerso>
                </div>
                <div className='col-auto'>
                    <CardPerso header={t('nbTickets')}>
                        <div className="table-responsive">
                            <table
                                id="stock_table"
                                className="table"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">{t('shop')}</th>
                                        <th className='text-end' scope="col">{t('nbTickets')}</th>
                                        <th className='text-end' scope="col">{t('nbTickets')} P2</th>
                                        <th className='text-end' scope="col">{'ecart'}</th>
                                        <th className='text-end' scope="col">{'ecart %'}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(loading) ? 
                                        <tr>
                                            <td className="spinner-border spinner-border-sm mt-2"></td>
                                        </tr>
                                    :
                                    
                                        <>
                                            {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                if(hide.length==0){
                                                    return(
                                                        <tr key={key}>
                                                            <td>{key}</td>
                                                            <td className='text-end'>{value.nbr_tickets}</td>
                                                            <td className='text-end'>{value.old.nbr_tickets}</td>
                                                            <td className='text-end'>{value.ecart.nbr_tickets}</td>
                                                            <td className='text-end'>{value.ecart_percent.nbr_tickets} %</td>
                                                        </tr>
                                                        
                                                    )
                                                }
                                            })}

                                            {(!section) &&
                                                <tr className='fw-bold'>
                                                    <td>Total</td>
                                                    <td className='text-end'>{totalCa.nbTickets}</td>
                                                    <td className='text-end'>{totalCaOld.nbTickets}</td>
                                                    <td className='text-end'>{totalCaEcart.nbTickets}</td>
                                                    <td className='text-end'>{totalCaEcartPercent.nbTickets} %</td>
                                                </tr>
                                            }
                                        </>

                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardPerso>
                </div>
                <div className='col-auto'>
                    <CardPerso header={t('passages')}>
                        <div className="table-responsive">
                            <table
                                id="stock_table"
                                className="table"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">{t('shop')}</th>
                                        <th className='text-end' scope="col">{t('passages')}</th>
                                        <th className='text-end' scope="col">{t('passages')} P2</th>
                                        <th className='text-end' scope="col">{'ecart'}</th>
                                        <th className='text-end' scope="col">{'ecart %'}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(loading) ?
                                        <tr>
                                            <td className="spinner-border spinner-border-sm mt-2"></td>
                                        </tr>
                                    :

                                        <>
                                            {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))
                                                if(hide.length==0){
                                                    return(
                                                        <tr key={key}>
                                                            <td>{key}</td>
                                                            <td className='text-end'>{value.entre ?? 0}</td>
                                                            <td className='text-end'>{value.old.entre ?? 0}</td>
                                                            <td className='text-end'>{value.ecart.entre ?? 0}</td>
                                                            <td className='text-end'>{value.ecart_percent?.entre ?? 0} %</td>
                                                        </tr>
                                                    )
                                                }
                                            })}

                                            {(!section) &&
                                                <tr className='fw-bold'>
                                                    <td>Total</td>
                                                    <td className='text-end'>{totalCa.nbEntre ?? 0}</td>
                                                    <td className='text-end'>{totalCaOld.nbEntre ?? 0}</td>
                                                    <td className='text-end'>{totalCaEcart.nbEntre ?? 0}</td>
                                                    <td className='text-end'>{totalCaEcartPercent.nbEntre ?? 0} %</td>
                                                </tr>
                                            }
                                        </>

                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardPerso>
                </div>
                <div className='col-auto'>
                    <CardPerso header={'TF'}>
                        <div className="table-responsive">
                            <table
                                id="stock_table"
                                className="table"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">{t('shop')}</th>
                                        <th className='text-end' scope="col">TF</th>
                                        <th className='text-end' scope="col">TF P2</th>
                                        <th className='text-end' scope="col">{'ecart'}</th>
                                        <th className='text-end' scope="col">{'ecart %'}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(loading) ?
                                        <tr>
                                            <td className="spinner-border spinner-border-sm mt-2"></td>
                                        </tr>
                                    :

                                        <>
                                            {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))
                                                if(hide.length==0){
                                                    return(
                                                        <tr key={key}>
                                                            <td>{key}</td>
                                                            <td className='text-end'>{Math.round((value.tf ?? 0) * 100) / 100} %</td>
                                                            <td className='text-end'>{Math.round((value.old.tf ?? 0) * 100) / 100} %</td>
                                                            <td className='text-end'>{Math.round((value.ecart.tf ?? 0) * 100) / 100}</td>
                                                            <td className='text-end'>{Math.round((value.ecart_percent?.tf ?? 0) * 100) / 100} %</td>
                                                        </tr>
                                                    )
                                                }
                                            })}

                                            {(!section) &&
                                                <tr className='fw-bold'>
                                                    <td>Total</td>
                                                    <td className='text-end'>{Math.round((totalCa.totalTf ?? 0) * 100) / 100} %</td>
                                                    <td className='text-end'>{Math.round((totalCaOld.totalTf ?? 0) * 100) / 100} %</td>
                                                    <td className='text-end'>{Math.round((totalCaEcart.totalTf ?? 0) * 100) / 100}</td>
                                                    <td className='text-end'>{totalCaEcartPercent.totalTf ?? 0} %</td>
                                                </tr>
                                            }
                                        </>

                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardPerso>
                </div>
                <div className='col-auto'>
                    <CardPerso header={t('bestTicket')}>
                        <div className="table-responsive">
                            <table
                                id="stock_table"
                                className="table"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">{t('shop')}</th>
                                        <th className='text-end' scope="col">{t('bestTicket')}</th>
                                        <th className='text-end' scope="col">{t('bestTicket')} P2</th>
                                        <th className='text-end' scope="col">{'ecart'}</th>
                                        <th className='text-end' scope="col">{'ecart %'}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(loading) ? 
                                        <tr>
                                            <td className="spinner-border spinner-border-sm mt-2"></td>
                                        </tr>
                                    :
                                    
                                        <>
                                            {Object.keys(ca).length!=0 && Object.entries(ca).map(([key,value]) =>{
                                                let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                if(hide.length==0){
                                                    return(
                                                        <tr key={key}>
                                                            <td>{key}</td>
                                                            <td className='text-end'>{<><FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.bigest_basket["montant"]} /> {'('+value.bigest_basket["ref"]+')'}</>}</td>
                                                            <td className='text-end'>{<><FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.old.bigest_basket["montant"]} /> {'('+value.old.bigest_basket["ref"]+')'}</>}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ecart.bigest_basket} />}</td>
                                                            <td className='text-end'>{value.ecart_percent.bigest_basket} %</td>
                                                        </tr>
                                                    )
                                                }
                                            })}
                                        </>

                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardPerso>
                </div>
            </div>
            {/* FILTRE KPI */}
            <div className="card p-3 mb-3">
                <div className="row align-items-center">
                    <div className="col-md-2 fw-bold">
                        {t('itemCompareFilter')} :
                    </div>
                    <div className="col-md-4">
                        <select
                            id="kpi_compare_filter1"
                            value={compareFilter.filter1}
                            className="form-control"
                            onChange={(e) =>
                                setCompareFilter({
                                    ...compareFilter,
                                    filter1: e.target.value
                                })
                            }
                        >
                            <option value="">{t('noSelection')}</option>
                            {kpiFilterList?.map((value) => (
                                <option key={value.id} value={value.id}>
                                    {value.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <select
                            id="kpi_compare_filter2"
                            value={compareFilter.filter2}
                            className="form-control"
                            onChange={(e) =>
                                setCompareFilter({
                                    ...compareFilter,
                                    filter2: e.target.value
                                })
                            }
                        >
                            <option value="">{t('noSelection')}</option>
                            {kpiFilterList?.map((value) => (
                                <option key={value.id} value={value.id}>
                                    {value.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <button className='btn btn-primary' disabled={btnValidateCompareFilter} onClick={() => handleClickCompareFilter()}>{(btnValidateCompareFilter) ? <span className="spinner-border spinner-border-sm"></span> : t('btnValidate')}</button>
                    </div>
                </div>
            </div>
            {(showCompare) &&
                <div className="row">
                    <div className='col-auto'>
                        <CardPerso header={t('cattc')}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">{t('cattc')}</th>
                                            <th className='text-end' scope="col">{t('cattc')+' 2'}</th>
                                            <th className='text-end' scope="col">Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(btnValidateCompareFilter) ? 
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :
                                        
                                            <>
                                                {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.cattc} />}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.compare.cattc} />}</td>
                                                                <td className='text-end'>{value.ratio.cattc} %</td>
                                                            </tr>
                                                            
                                                        )
                                                    }
                                                })}
                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaCompare.totalCaTtc} />}</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaCompare2.totalCaTtc} />}</td>
                                                        <td className='text-end'>{totalCaRatioCompare.totalCaTtc} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                    {(!section) &&
                        <div className='col-auto'>
                            <CardPerso header={t('caht')}>
                                <div className="table-responsive">
                                    <table
                                        id="stock_table"
                                        className="table"
                                    >
                                        <thead>
                                            <tr>
                                                <th scope="col">{t('shop')}</th>
                                                <th className='text-end' scope="col">{t('caht')}</th>
                                                <th className='text-end' scope="col">{t('caht')+' 2'}</th>
                                                <th className='text-end' scope="col">Ratio</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {(btnValidateCompareFilter) ? 
                                                <tr>
                                                    <td className="spinner-border spinner-border-sm mt-2"></td>
                                                </tr>
                                            :
                                            
                                                <>
                                                    {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                        let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                        if(hide.length==0){
                                                            return(
                                                                <tr key={key}>
                                                                    <td>{key}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.caht} />}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.compare.caht} />}</td>
                                                                    <td className='text-end'>{value.ratio.caht} %</td>
                                                                </tr>
                                                                
                                                            )
                                                        }
                                                    })}

                                                    {(!section) &&
                                                        <tr className='fw-bold'>
                                                            <td>Total</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCa.totalCaHt} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaCompare2.totalCaHt} />}</td>
                                                            <td className='text-end'>{totalCaRatioCompare.totalCaHt} %</td>
                                                        </tr>
                                                    }
                                                </>

                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </CardPerso>
                        </div>
                    }
                    <div className='col-auto'>
                        <CardPerso header={"PM TTC"}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">PM TTC</th>
                                            <th className='text-end' scope="col">PM TTC 2</th>
                                            <th className='text-end' scope="col">Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(btnValidateCompareFilter) ? 
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :
                                        
                                            <>
                                                {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.pmttc} />}</td>
                                                                <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.compare.pmttc} />}</td>
                                                                <td className='text-end'>{value.ratio.pmttc} %</td>
                                                            </tr>
                                                            
                                                        )
                                                    }
                                                })}

                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaCompare.totalPmTtc} />}</td>
                                                        <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={totalCaCompare2.totalPmTtc} />}</td>
                                                        <td className='text-end'>{totalCaRatioCompare.totalPmTtc} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                    {(!section) &&
                        <div className='col-auto'>
                            <CardPerso header={'PM'}>
                                <div className="table-responsive">
                                    <table
                                        id="stock_table"
                                        className="table"
                                    >
                                        <thead>
                                            <tr>
                                                <th scope="col">{t('shop')}</th>
                                                <th className='text-end' scope="col">PM</th>
                                                <th className='text-end' scope="col">PM 2</th>
                                                <th className='text-end' scope="col">Ratio</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {(btnValidateCompareFilter) ? 
                                                <tr>
                                                    <td className="spinner-border spinner-border-sm mt-2"></td>
                                                </tr>
                                            :
                                            
                                                <>
                                                    {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                        let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                        if(hide.length==0){
                                                            return(
                                                                <tr key={key}>
                                                                    <td>{key}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.pmht} />}</td>
                                                                    <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.compare.pmht} />}</td>
                                                                    <td className='text-end'>{value.ratio.pmht} %</td>
                                                                </tr>
                                                                
                                                            )
                                                        }
                                                    })}

                                                    {(!section) &&
                                                        <tr className='fw-bold'>
                                                            <td>Total</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(totalCaCompare.nbTickets!=0) ? totalCaCompare.totalCaHt/totalCaCompare.nbTickets : 0} />}</td>
                                                            <td className='text-end'>{<FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={(totalCaCompare2.nbTickets!=0) ? totalCaCompare2.totalCaHt/totalCaCompare2.nbTickets : 0} />}</td>
                                                            <td className='text-end'>{totalCaRatioCompare.totalPm} %</td>
                                                        </tr>
                                                    }
                                                </>

                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </CardPerso>
                        </div>
                    }
                    <div className='col-auto'>
                        <CardPerso header={'IV'}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">IV</th>
                                            <th className='text-end' scope="col">IV 2</th>
                                            <th className='text-end' scope="col">Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(btnValidateCompareFilter) ? 
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :
                                        
                                            <>
                                                {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{value.iv}</td>
                                                                <td className='text-end'>{value.compare.iv}</td>
                                                                <td className='text-end'>{value.ratio.iv} %</td>
                                                            </tr>
                                                            
                                                        )
                                                    }
                                                })}

                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{totalCaCompare.totalIv}</td>
                                                        <td className='text-end'>{totalCaCompare2.totalIv}</td>
                                                        <td className='text-end'>{totalCaRatioCompare.totalIv} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                    <div className='col-auto'>
                        <CardPerso header={t('passages')}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">{t('passages')}</th>
                                            <th className='text-end' scope="col">{t('passages')} 2</th>
                                            <th className='text-end' scope="col">Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(btnValidateCompareFilter) ?
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :

                                            <>
                                                {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{value.entre ?? 0}</td>
                                                                <td className='text-end'>{value.compare.entre ?? 0}</td>
                                                                <td className='text-end'>{value.ratio?.entre ?? 0} %</td>
                                                            </tr>
                                                        )
                                                    }
                                                })}

                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{totalCaCompare.nbEntre ?? 0}</td>
                                                        <td className='text-end'>{totalCaCompare2.nbEntre ?? 0}</td>
                                                        <td className='text-end'>{totalCaRatioCompare.nbEntre ?? 0} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                    <div className='col-auto'>
                        <CardPerso header={'TF'}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">TF</th>
                                            <th className='text-end' scope="col">TF 2</th>
                                            <th className='text-end' scope="col">Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(btnValidateCompareFilter) ?
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :

                                            <>
                                                {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{Math.round((value.tf ?? 0) * 100) / 100} %</td>
                                                                <td className='text-end'>{Math.round((value.compare.tf ?? 0) * 100) / 100} %</td>
                                                                <td className='text-end'>{Math.round((value.ratio?.tf ?? 0) * 100) / 100} %</td>
                                                            </tr>
                                                        )
                                                    }
                                                })}

                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{Math.round((totalCaCompare.totalTf ?? 0) * 100) / 100} %</td>
                                                        <td className='text-end'>{Math.round((totalCaCompare2.totalTf ?? 0) * 100) / 100} %</td>
                                                        <td className='text-end'>{totalCaRatioCompare.totalTf ?? 0} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                    <div className='col-auto'>
                        <CardPerso header={t('itemsNumber')}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">{t('itemsNumber')}</th>
                                            <th className='text-end' scope="col">{t('itemsNumber')} 2</th>
                                            <th className='text-end' scope="col">Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(btnValidateCompareFilter) ? 
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :
                                        
                                            <>
                                                {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{Math.round(value.nbr_articles*100)/100}</td>
                                                                <td className='text-end'>{Math.round(value.compare.nbr_articles*100)/100}</td>
                                                                <td className='text-end'>{Math.round(value.ratio.nbr_articles*100)/100} %</td>
                                                            </tr>
                                                            
                                                        )
                                                    }
                                                })}

                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{Math.round(totalCaCompare.nbArticles*100)/100}</td>
                                                        <td className='text-end'>{Math.round(totalCaCompare2.nbArticles*100)/100}</td>
                                                        <td className='text-end'>{Math.round(totalCaRatioCompare.nbArticles*100)/100} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                    <div className='col-auto'>
                        <CardPerso header={t('nbTickets')}>
                            <div className="table-responsive">
                                <table
                                    id="stock_table"
                                    className="table"
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('shop')}</th>
                                            <th className='text-end' scope="col">{t('nbTickets')}</th>
                                            <th className='text-end' scope="col">{t('nbTickets')} 2</th>
                                            <th className='text-end' scope="col">Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {(btnValidateCompareFilter) ? 
                                            <tr>
                                                <td className="spinner-border spinner-border-sm mt-2"></td>
                                            </tr>
                                        :
                                        
                                            <>
                                                {Object.keys(caCompare).length!=0 && Object.entries(caCompare).map(([key,value]) =>{
                                                    let hide = value.hide_access.filter(val=>(val.user_id==authParam.userid) && (val.module=='pos'))//va servir à savoir si on masque l'accès
                                                    if(hide.length==0){
                                                        return(
                                                            <tr key={key}>
                                                                <td>{key}</td>
                                                                <td className='text-end'>{value.nbr_tickets}</td>
                                                                <td className='text-end'>{value.compare.nbr_tickets}</td>
                                                                <td className='text-end'>{value.ratio.nbr_tickets} %</td>
                                                            </tr>
                                                            
                                                        )
                                                    }
                                                })}

                                                {(!section) &&
                                                    <tr className='fw-bold'>
                                                        <td>Total</td>
                                                        <td className='text-end'>{totalCaCompare.nbTickets}</td>
                                                        <td className='text-end'>{totalCaCompare2.nbTickets}</td>
                                                        <td className='text-end'>{totalCaRatioCompare.nbTickets} %</td>
                                                    </tr>
                                                }
                                            </>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardPerso>
                    </div>
                </div>
            }
        </>
    )
};

export default TurnoverPos;